module.exports = __webpack_public_path__ + "img/chocolate-ice-cream-dessert1.c73e0399.png";